import { useState } from "react";
import classNames from "classnames";
import { DropDown, Typography } from "components/atoms";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

interface IProps {
  item: any;
}

export const InstructorMobile = ({ item }: IProps) => {
  const [instructorDropdown, setInstructorDropdown] = useState<
    null | string | { [key: number]: string }
  >(null);

  const getSubmittedClassDateStatus = (obj: any) => {
    const startTime = obj.NearFutureSegments.find(
      (segment: any) =>
        segment.ProductOfferingSegmentId === obj.ProductOfferingSegmentId
    ).StarttimeUTC;
    return dayjs(startTime).isValid()
      ? dayjs.utc(startTime).local().format("MM/DD/YY")
      : startTime;
  };

  const getSubmittedInstructorStatus = (obj: any) => {
    const record = obj.NearFutureSegments.find(
      (segment: any) =>
        segment.ProductOfferingSegmentId === obj.ProductOfferingSegmentId
    );
    return record.InstructorName;
  };

  return item.NearFutureSegments &&
    Array.isArray(item.NearFutureSegments) &&
    item.NearFutureSegments.length > 0 ? (
    item.IsAddedToHome === false ? (
      <div className={classNames("pending-class-wrapper")}>
        <div className={classNames("inner-wrapper")}>
          <Typography variant="h8Med" label="Class Date" />
          <Typography variant="h8Med" label="Instructor Name" />
        </div>
        <DropDown
          defaultSelected={instructorDropdown}
          setDropDownSelection={setInstructorDropdown}
          placeholder="Select a class date and instructor"
          data={item.NearFutureSegments.map(
            (value: any) =>
              `${
                dayjs(value.StarttimeUTC).isValid()
                  ? dayjs(value.StarttimeUTC).format("MM/DD/YY HH:mm")
                  : value.StarttimeUTC
              } ${value.InstructorName}`
          )}
        />
      </div>
    ) : (
      <div className={classNames("attended-class-wrapper")}>
        <div className={classNames("inner-wrapper")}>
          <Typography variant="h8Med" label="Class Date" />
          <Typography
            styles="progress-summary-mobile-normal-text"
            variant="h8Book"
            label={getSubmittedClassDateStatus(item)}
          />
        </div>
        <div className={classNames("inner-wrapper")}>
          <Typography variant="h8Med" label="Instructor Name" />
          <Typography
            styles="progress-summary-mobile-normal-text"
            variant="h8Book"
            label={getSubmittedInstructorStatus(item) || "Unknown"}
          />
        </div>
      </div>
    )
  ) : (
    <div className={classNames("attended-class-wrapper")}>
      <div className={classNames("inner-wrapper")}>
        <Typography variant="h8Med" label="Class Date" />
        <Typography
          styles="progress-summary-mobile-normal-text"
          variant="h8Book"
          label={
            (dayjs(item.DueDate).isValid()
              ? dayjs(item.DueDate).format("MM/DD/YY HH:mm")
              : item.DueDate) ||
            (dayjs(item.ClassDate).isValid()
              ? dayjs(item.ClassDate).format("MM/DD/YY HH:mm")
              : item.ClassDate)
          }
        />
      </div>
      <div className={classNames("inner-wrapper")}>
        <Typography variant="h8Med" label="Instructor Name" />
        <Typography
          styles="progress-summary-mobile-normal-text"
          variant="h8Book"
          label={
            (item.NearFutureSegments &&
              Array.isArray(item.NearFutureSegments) &&
              item.NearFutureSegments.length > 0 &&
              item.NearFutureSegments[0].InstructorName) ||
            "Unknown"
          }
        />
      </div>
    </div>
  );
};
